export default __webpack_public_path__ + "static/media/thoughts.643b8cc4.jpg";